import React, { Suspense, useEffect } from "react";
import { useDispatch } from "react-redux";

function Index() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: "CLEAR",
    });
    window.location.replace("/");
  }, []);
  return <Suspense fallback={<div>Loading... </div>}></Suspense>;
}

export default Index;